// @ts-ignore
import styles from './VideoThumbnail.module.scss';
import { useState } from 'react';
import { joinClasses } from '../../../Utils/className.util';

interface VideoThumbnail {
	src: string;
	title: string;
}

export default function VideoThumbnail(props: VideoThumbnail) {
	const { src, title } = props;
	const [active, setActive] = useState(null);

	const handleToggleActive = () => {
		setActive(prevValue => !prevValue);
	};

	return (
		<div
			className={joinClasses([styles.wrapper, active && styles.borderActive])}>
			<div
				className={joinClasses([styles.checkbox, active && styles.active])}
				onClick={handleToggleActive}
			/>
			<iframe
				style={{ aspectRatio: '16/9' }}
				src={src}
				width={'100%'}
				height={'auto'}
				frameBorder={'0'}
				allow={'autoplay; fullscreen'}
				allowFullScreen
			/>
			<div className={styles.title}>{title}</div>
		</div>
	);
}
